export const FeatureFlags = {
  campus_flow: {
    flagKey: "ENG-4047_campus_flow",
    defaultValue: false,
  },
}
